import { useEffect } from 'react';
import { persistUTMParams } from './utm';

export const UTMManager = () => {
  useEffect(() => {
    persistUTMParams();
  }, []);

  return null;
};
